import { LineSegments, Mesh, Object3D } from 'three';
import { ThreeJsMeshLike } from './three-js-mesh-like';

export function isMeshLike(object: Object3D): object is ThreeJsMeshLike {
  return isMesh(object) || isLineSegments(object);
}

export function isMesh(object: Object3D): object is Mesh {
  return (object as Mesh).isMesh;
}

export function isLineSegments(object: Object3D): object is LineSegments {
  return (object as LineSegments).isLineSegments;
}
